import type { Field, FieldType, GeneratorConfigV1 } from '../types/generator-config';

export interface FieldRef {
    field: Field;
    stepTitle: string;
    stepIndex: number;
    fieldIndex: number;
}

/** Aplatit tous les fields de la config avec leur contexte (step) */
export function listAllFields(config: GeneratorConfigV1): FieldRef[] {
    const out: FieldRef[] = [];
    config.steps.forEach((step, si) => {
        step.fields.forEach((field, fi) => {
            out.push({ field, stepTitle: step.title, stepIndex: si, fieldIndex: fi });
        });
    });
    return out;
}

/** Retourne un field par id, si présent dans la config */
export function getFieldById(config: GeneratorConfigV1, id: string): Field | undefined {
    for (const step of config.steps) {
        for (const f of step.fields) {
            if (f.id === id) return f;
        }
    }
    return undefined;
}

/** Opérateurs de condition admis pour chaque type de field */
export type ConditionOperator =
    | 'equals'
    | 'notEquals'
    | 'in'
    | 'notIn'
    | 'includes';

export function operatorsForFieldType(type: FieldType): ConditionOperator[] {
    switch (type) {
        case 'select':
        case 'radio':
            return ['equals', 'notEquals', 'in', 'notIn'];
        case 'chips':
            // Pour un chips multi on privilégie includes, mais equals marche aussi.
            return ['equals', 'notEquals', 'in', 'notIn', 'includes'];
        case 'checkbox-group':
            return ['includes'];
        case 'slider':
        case 'number':
            return ['equals', 'notEquals'];
        case 'textarea':
            return [];
    }
}

export function operatorLabel(op: ConditionOperator): string {
    const map: Record<ConditionOperator, string> = {
        equals: 'est égal à',
        notEquals: "n'est pas égal à",
        in: 'est parmi',
        notIn: "n'est pas parmi",
        includes: 'contient',
    };
    return map[op];
}

/** Types de fields qui supportent les règles de visibilité comme source de condition */
export function fieldTypeCanBeConditionSource(type: FieldType): boolean {
    return operatorsForFieldType(type).length > 0;
}
